import http from '@/utils/http'

export function getHomeworks(params){
    return  http('/homeworks',{params})
}

export function getHomeworksDetail(id){
    return  http(`/homeworks/${id}`)
}

export function putHomeworksAnswer(id,data){
    return  http.post(`/homeworks/${id}/answer_result`,data)
}